<template>
  <div class="fixed z-50 w-full hover:bg-white" @mouseenter="mouseOver" @mouseleave="mouseOut"
    :class="{ 'bg-white': isActive}">
    <!--    <nav class="h-6 leading-6 firstNav"  :style="firstNavStyle">-->
    <!--      <div class="container px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10 md:flex flex flex-row items-center justify-between">-->
    <!--          <div class="h-6  textClass hover:text-black">-->
    <!--            Hi 欢迎来到EMHUB-->
    <!--          </div>-->
    <!--          <div class="h-6 textClass ">-->
    <!--            <span class="cursor-pointer hover:text-black divSon">CN</span>-->
    <!--            <span class="mx-2 divSon">/</span>-->
    <!--            <span class="cursor-pointer hover:text-black divSon">EN</span>-->
    <!--            <span class="mx-4 divSon">|</span>-->
    <!--            <span class="cursor-pointer hover:text-black divSon" @click="login">登录</span>-->
    <!--          </div>-->
    <!--      </div>-->
    <!--    </nav>-->

    <nav class=" border-none twoNav">
      <div
        class="container px-4 mx-auto py-3 md:flex sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
        <div class="flex items-center justify-between">
          <!--   logo     -->
          <div v-show="!isActive">
            <!--滑动条在顶部-->
            <a v-show="whiteBool" @click="toIndex"
              class="text-2xl font-bold transition-colors duration-200 transform lg:text-3xl hover:text-black"
              href="javascript:;">
              <img :src="baseOSSUrl + '/logo-white.png'" style="max-width: 160px;max-height: 43px;" alt="loading">
            </a>
            <a v-show="!whiteBool" @click="toIndex"
              class="text-2xl font-bold transition-colors duration-200 transform lg:text-3xl hover:text-black"
              href="javascript:;">
              <img :src="baseOSSUrl + '/logo-black.png'" style="max-width: 160px;max-height: 43px;" alt="loading">
            </a>
          </div>
          <div v-show="isActive">
            <a @click="toIndex"
              class="text-2xl font-bold transition-colors duration-200 transform lg:text-3xl hover:text-black"
              href="javascript:;">
              <img :src="baseOSSUrl + '/logo-black.png'" style="max-width: 160px;max-height: 43px;" alt="loading">
            </a>
          </div>
          <!-- Mobile menu button -->
          <div class="flex md:hidden">
            <button type="button" @click="toggle();"
              class="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400"
              aria-label="toggle menu">
              <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                <path fill-rule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z">
                </path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile Menu open: "block", Menu closed: "hidden" " -->
        <div :class="menuClassObj">
          <div class="flex flex-col px-2 py-3 -mx-4 md:flex-row md:mx-0 md:py-0 rounded" v-show="!showMenu">
            <div v-if="!showModal">
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,1);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">EMHUB<i
                    :class="arrowWay1" class="w-3 h-3"></i></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="aboutEmhub">&ensp;&ensp;关于EMHUB&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toNewsList">&ensp;&ensp;新闻动态&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,2);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">临床服务<i
                    :class="arrowWay2"></i></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toClinical(0)">&ensp;&ensp;专家库</el-dropdown-item>
                  <el-dropdown-item @click.native="toClinical(1)">&ensp;&ensp;多学科会诊/第二诊疗意见</el-dropdown-item>
                  <el-dropdown-item @click.native="toClinical(2)">&ensp;&ensp;研究型国际医院&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,3);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool}">在线教育<i
                    :class="arrowWay3"></i></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toEdu(0)">&ensp;&ensp;精彩直播&ensp;&ensp;</el-dropdown-item>
                  <!--                  <el-dropdown-item @click.native="toEdu(1)">&ensp;&ensp;认证教育&ensp;&ensp;</el-dropdown-item>-->
                  <el-dropdown-item @click.native="toEdu(2)">&ensp;&ensp;学位教育&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,4);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">科学研究<i
                    :class="arrowWay4"></i></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toScience(0)">&ensp;&ensp;成果转化&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toScience(1)">&ensp;&ensp;产业基金&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toScience(2)">&ensp;&ensp;生命科学园&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,5);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">合作伙伴<i
                    :class="arrowWay5"></i></a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toPartner">&ensp;&ensp;临床服务&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toPartner">&ensp;&ensp;在线教育&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toPartner">&ensp;&ensp;科学研究&ensp;&ensp;</el-dropdown-item>
                  <el-dropdown-item @click.native="toPartner">&ensp;&ensp;其他合作&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown :placement="placement" :show-timeout="showTimeout"
                @visible-change="visibleChange($event ,6);"
                class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
                <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">联系我们<i
                    :class="arrowWay6"></i></a>
                <el-dropdown-menu slot="dropdown" class="header-new-drop">
                  <el-dropdown-item @click.native="support">&ensp;&ensp;联系我们&ensp;&ensp;</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-if="showModal">
            <el-input class="w-72 opacity-40" ref="search" @keyup.enter.native="submitForm()" @blur="showModal=false"
              v-model="seacrchValue" placeholder="关键词搜索" prefix-icon="el-icon-search"></el-input>
          </div>
        </div>
        <div v-if="memberName==''"
          class="nav-item md:flex md:items-center md:justify-center text-base font-medium hover:text-black text-gray-500 cursor-pointer"
          :class="{ 'whiteClass': whiteBool }" style="width: 3.125rem;height: 3.125rem;" @click="login">
          登录
        </div>
        <div v-else
          class="nav-item md:flex md:items-center md:justify-center text-base font-medium hover:text-black text-gray-500 cursor-pointer"
          :class="{ 'whiteClass': whiteBool }" style="width: 3.125rem;height: 3.125rem;">
          <el-dropdown :placement="placement" :show-timeout="showTimeout" @visible-change="visibleChange($event ,7);"
            class="px-2 py-1 text-base font-medium transition-colors duration-200 transform rounded hover:text-black md:mx-2">
            <a href="javascript:;" class="el-dropdown-link" :class="{ 'whiteClass': whiteBool }">{{memberName}}</a>
            <el-dropdown-menu slot="dropdown" class="header-new-drop">
              <el-dropdown-item v-show="isIncludeDoctorRole" @click.native="toMDT">&ensp;&ensp;MDT&ensp;&ensp;
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout">&ensp;&ensp;退出&ensp;&ensp;</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!--        <div class="nav-item opacity-100 md:flex md:items-center md:justify-center" style="color: #606266">-->
        <!--          <a href="#" v-if="!showModal"  @click="showSearchInput()">-->
        <!--            <svg class="hover:text-black fill-current h-6 w-6" :class="{ 'whiteClass': whiteBool }" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">-->
        <!--              <path d="M20.067 18.933l-4.157-4.157a6 6 0 1 0-.884.884l4.157 4.157a.624.624 0 1 0 .884-.884zM6.5 11c0-2.62 2.13-4.75 4.75-4.75S16 8.38 16 11s-2.13 4.75-4.75 4.75S6.5 13.62 6.5 11z"></path>-->
        <!--            </svg>-->
        <!--          </a>-->
        <!--        </div>-->
      </div>
    </nav>
  </div>



</template>


<script>
  import {
    baseOSSUrl
  } from '@/utils/oss';
  export default {
    name: 'homeNav',
    data() {
      return {
        baseOSSUrl,
        toggleBool: false, //按钮控制菜单是否显示
        menuClassObj: "w-full md:flex md:items-center md:justify-center hidden", //菜单默认class
        arrowWay1: "el-icon-arrow-down el-icon--right", //nav箭头方向
        arrowWay2: "el-icon-arrow-down el-icon--right",
        arrowWay3: "el-icon-arrow-down el-icon--right",
        arrowWay4: "el-icon-arrow-down el-icon--right",
        arrowWay5: "el-icon-arrow-down el-icon--right",
        arrowWay6: "el-icon-arrow-down el-icon--right",
        arrowWay7: "el-icon-arrow-down el-icon--right",
        showTimeout: 100, //下拉菜单显示快慢
        placement: "bottom", //菜单弹出位置  bottom 底部
        showMenu: false, //小屏状态下是否显示菜单:  true显示 false不显示
        showModal: false, //默认不显示搜索框:   true显示 false不显示
        seacrchValue: "", //搜索内容
        isActive: false, //滚轮不在顶部显示nav背景颜色
        scrollTop: 0, //滑动条距离顶部位置
        firstNavBool: true, //第一个nav块是否显示透明度 true有透明度，false关闭透明度
        firstNavStyle: '', //第一个nav块样式
        dropMenuBool: false, //下拉菜单是否打开 false关闭 true打开
        whiteBool: true, //是否显示白色字体:  true显示 false不显示
        mouseInNavBool: false, //鼠标是否在大nav块内: true在 false不在。
        tabIndex: 0,
        memberName: "",
        isIncludeDoctorRole: false
      }
    },
    methods: {
      //小屏打开菜单栏开关
      toggle() {
        this.toggleBool = !this.toggleBool;
        if (this.toggleBool) {
          //true显示
          this.menuClassObj = "w-full md:flex md:items-center md:justify-center block"
        } else {
          this.menuClassObj = "w-full md:flex md:items-center md:justify-center hidden"
        }
      },
      //切换菜单栏箭头方向
      visibleChange(item, val) {
        //true显示 箭头向上 ;false隐藏 箭头向下
        if (item) {
          this.dropMenuBool = true;
          this.isActive = true;
          this.setArrowUpClass(val);
          this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
        } else {
          this.dropMenuBool = false;
          if (this.scrollTop == 0) {
            this.isActive = false;
            if (this.mouseInNavBool) {
              this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
              this.whiteBool = false;
            } else {
              this.firstNavStyle = "{background: rgba(255,255,255,0.1);color:white;}";
              this.whiteBool = true;
            }
          } else {
            this.isActive = true;
          }
          this.setArrowDownClass(val);
        }
      },
      setArrowUpClass(val) {
        if (val == 1) {
          this.arrowWay1 = "el-icon-arrow-up el-icon--right";
        } else if (val == 2) {
          this.arrowWay2 = "el-icon-arrow-up el-icon--right";
        } else if (val == 3) {
          this.arrowWay3 = "el-icon-arrow-up el-icon--right";
        } else if (val == 4) {
          this.arrowWay4 = "el-icon-arrow-up el-icon--right";
        } else if (val == 5) {
          this.arrowWay5 = "el-icon-arrow-up el-icon--right";
        } else if (val == 6) {
          this.arrowWay6 = "el-icon-arrow-up el-icon--right";
        } else if (val == 7) {
          this.arrowWay7 = "el-icon-arrow-up el-icon--right";
        }
      },
      setArrowDownClass(val) {
        if (val == 1) {
          this.arrowWay1 = "el-icon-arrow-down el-icon--right";
        } else if (val == 2) {
          this.arrowWay2 = "el-icon-arrow-down el-icon--right";
        } else if (val == 3) {
          this.arrowWay3 = "el-icon-arrow-down el-icon--right";
        } else if (val == 4) {
          this.arrowWay4 = "el-icon-arrow-down el-icon--right";
        } else if (val == 5) {
          this.arrowWay5 = "el-icon-arrow-down el-icon--right";
        } else if (val == 6) {
          this.arrowWay6 = "el-icon-arrow-down el-icon--right";
        } else if (val == 7) {
          this.arrowWay7 = "el-icon-arrow-down el-icon--right";
        }
      },
      //搜索提交
      submitForm() {
        this.showModal = !this.showModal;
      },
      handleScroll() {
        //获取滚动距顶部的距离，显示
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (this.scrollTop == 0) {
          this.isActive = false;
          this.firstNavStyle = "{background: rgba(255,255,255,0.1);color:white;}";
          this.whiteBool = true;
        } else {
          this.isActive = true;
          this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
          this.whiteBool = false;
        }
      },
      //鼠标在nav上
      mouseOver() {
        this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
        this.whiteBool = false;
        this.mouseInNavBool = true;
      },
      mouseOut() {
        this.mouseInNavBool = false;
        //第一种情况 滑动条在顶部  在下拉菜单中
        if (this.scrollTop == 0 && this.dropMenuBool) {
          this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
          this.whiteBool = false;
        }
        //第二种情况 滑动条在顶部  不在下拉菜单中
        if (this.scrollTop == 0 && !this.dropMenuBool) {
          this.firstNavStyle = "{background: rgba(255,255,255,0.1);color:white;}";
          this.whiteBool = true;
        }
        //第三种情况 滑动条不在顶部  在下拉菜单中
        if (this.scrollTop != 0 && this.dropMenuBool) {
          this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
          this.whiteBool = false;
        }
        //第四种情况 滑动条不在顶部  不在下拉菜单中
        if (this.scrollTop != 0 && !this.dropMenuBool) {
          this.firstNavStyle = "{background: rgba(255,255,255,1);color: #606266;}";
          this.whiteBool = false;
        }

      },
      login() {
        this.$router.push({
          name: 'login',
        })
      },
      //跳转科学研究页面事件
      toScience(value) {
        this.$router.replace({
          name: 'scienceResearch',
          query: {
            tabIndex: value
          }
        })
        this.$emit('switchTab', value)
      },
      //跳转合作伙伴页面事件
      toPartner() {
        this.$router.replace({
          name: 'partner'
        })
      },
      //跳转临床页面事件
      toClinical(value) {
        this.$router.replace({
          name: 'clinicalService',
          query: {
            tabIndex: value
          }
        })
        this.$emit('switchTab', value)
      },
      //跳转首页面事件
      toIndex() {
        this.$router.push({
          path: '/'
        })
      },
      //跳转教育页面
      toEdu(value) {
        this.$router.replace({
          name: 'edu',
          query: {
            tabIndex: value
          }
        })
        this.$emit('switchTab', value)
      },
      //跳转新闻列表
      toNewsList() {
        this.$router.push({
          name: 'newsList',
        })
      },
      //显示搜索框
      showSearchInput() {
        this.showModal = true;
        this.$nextTick(() => {
          this.$refs["search"].focus();
        })
      },
      //关于emhub
      aboutEmhub() {
        this.$router.push({
          name: 'emhub',
        })
      },
      //联系我们
      support() {
        this.$router.push({
          name: 'support',
        })
      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      toMDT() {
        window.location.replace(
          "http://101.132.179.36/trakcare/test/web/csp/Custom.CNXX.AuthSSO.Emhub.RequestURL.cls?tkSystemUI=1")
        // window.location.href="http://101.132.179.36/trakcare/test/web/csp/Custom.CNXX.AuthSSO.Emhub.RequestURL.cls?tkSystemUI=1"
      }
    },
    mounted: function () {
      // 监听（绑定）滚轮滚动事件
      window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed() {
      //离开页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
      this.memberName = this.$store.getters.name;
      var roles = this.$store.getters.roles;
      if (null != roles) {
        this.isIncludeDoctorRole = roles.includes("医生");
      } else {
        this.isIncludeDoctorRole = false;
      }
    }
  }
</script>


<style scoped>
  .textClass {
    font-size: 0.875rem;
  }

  .el-dropdown-menu /deep/ .el-dropdown-menu__item:hover {
    background-color: white;
    color: black;
  }

  .firstNav {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  .whiteClass {
    color: white;
  }
</style>